export const ROYALTY_REPORT_SHOW_TABS = ['general', 'breakdown'] as const;

export type RoyaltyReportShowTab = (typeof ROYALTY_REPORT_SHOW_TABS)[number];

export const ROYALTY_REPORT_DEFAULT_TAB: RoyaltyReportShowTab = 'general';

/** `?statement=` — the statement version the breakdown tab shows. */
export const ROYALTY_REPORT_STATEMENT_PARAM = 'statement';
